import React from 'react';
import { useDispatch } from 'react-redux';
import { closeGameSocket, sendGameMessage } from '../../redux/actions';
import Panel from '../Site/Panel';
import CardImage from './CardImage';
import cardsLogo from '../../assets/img/ShowHandIcon.png';

import './WinLoseSplash.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice, faDroplet } from '@fortawesome/free-solid-svg-icons';

const WinLoseSplash = ({ game, onCloseClick }) => {
    const dispatch = useDispatch();

    const onLeaveClick = () => {
        dispatch(sendGameMessage('leavegame'));
        dispatch(closeGameSocket());
    };

    let loser = null;
    let winner = null;

    for (const player in game.players) {
        const p = game.players[player];
        if (p.name === game.winner) {
            winner = p;
        } else {
            loser = p;
        }
    }

    const headerMessage = winner?.name + ' ' + 'wins!';
    const card = winner?.champions[0];
    // const winner = game.players[game.winner];
    return (
        <Panel title='Game Over' cardClass={`splash`} onCloseClick={onCloseClick}>
            <div className='central'>
                <h2 className='lobby-header'>{headerMessage}</h2>
                <div className='splash-card-wrapper'>
                    <div className='splash-card'>
                        <CardImage card={winner?.champions[0]} />
                    </div>
                    <div className='splash-card'>

                        <CardImage card={winner?.champions[1]} />
                    </div>
                    <div className='splash-card'>
                        <CardImage card={winner?.champions[2]} />
                    </div>


                </div>

                <div className='buttonDiv'>
                    <button
                        onClick={onLeaveClick}
                        className='btn splash-button btn-default'
                    >Leave Game</button>
                    <button
                        onClick={onCloseClick}
                        className='btn splash-button btn-primary'
                    >Close</button>
                </div>
            </div >
        </Panel >
    );
};

export default WinLoseSplash;
